<script>
import ReadOnly from "@/views/product/components/product-card/composition/substance/ReadOnlyV2.vue";
import Edit from "@/views/product/components/product-card/composition/substance/EditV2.vue";

export default {
    components: {ReadOnly, Edit},
    props: {
        compactView: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: true
        },
        readOnlyMode: {
            type: String,
            default: 'stacked'
        },
        substance: {
            type: Object,
            default() {
                return {
                    substance: {
                        title: ''
                    },
                    details: {}
                };
            }
        }
    },
    methods: {
        exclude(substance) {
            this.$emit('exclude', substance);
        },
        change(s, details) {
            this.$emit('change', this.substance, details);
        }
    }
}
</script>

<template>
    <div>
        <ReadOnly
            v-if="readOnly"
            :mode="readOnlyMode"
            :substance="substance"
            :compact-view="compactView"
        />
        <Edit
            v-else
            :substance="substance"
            :compact-view="compactView"
            @exclude="exclude"
            @change="change"
        />
    </div>
</template>
